import { initializeApp } from 'firebase/app';
import { collection, doc, getDocs, getFirestore, onSnapshot } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASECONFIG_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASECONFIG_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASECONFIG_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASECONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASECONFIG_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASECONFIG_APP_ID
};

const app = initializeApp(firebaseConfig);

export const db: any = getFirestore(app);

export const getBrands = async () => {
  const brandsArr: any = [];
  const colRef = collection(db, 'brands');
  const docsSnap = await getDocs(colRef);
  docsSnap.forEach((doc) => {
    brandsArr.push(doc.data());
  });
  return brandsArr;
};

export const getGeneralSurgeSnapshot = (id: string, callback: (args: any) => void) =>
  onSnapshot(doc(db, 'general_surge', id), (doc) => callback({ ...doc.data(), id: doc.id }));

export const getDeliveryValuesSnapshot = (callback: (args: any) => void) =>
  onSnapshot(doc(db, 'delivery_values', 'delivery_values'), (doc) =>
    callback({ ...doc.data(), id: doc.id })
  );

export const getPolygonSurge = (polygonId: string, callback: (args: any) => void) =>
  onSnapshot(doc(db, 'cokitchen_polygon_surge', polygonId), (doc) =>
    callback({ ...doc.data(), id: doc.id })
  );
